export const ErrorNotifier = {
  notify: (msg, details = {}) => {
    try {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(`*** ROLLBAR ERROR ***: "${msg}" details: ${JSON.stringify(details)}`);
      } else if (window.Rollbar) {
        Rollbar.error(msg, details);
      }
    } catch {
      // Let's be as safe as possible: we never want error reporting to cause a crash.
      // eslint-disable-next-line no-console
      console.log('Something went wrong trying to report an error.');
    }
  },
};
